/**
 * Decodes the payload of a JWT. Handles base64url (RFC 7515) and UTF-8.
 * Returns null when the token is malformed. It does not verify the signature or expiry.
 */
export function decodeJwtPayload<T>(token: string | null | undefined): T | null {
  if (!token) return null;
  try {
    const part = token.split('.')[1];
    if (!part) return null;
    const base64 = part.replace(/-/g, '+').replace(/_/g, '/');
    const padded = base64 + '='.repeat((4 - (base64.length % 4)) % 4);
    const binary = atob(padded);
    const bytes = Uint8Array.from(binary, (c) => c.charCodeAt(0));
    return JSON.parse(new TextDecoder().decode(bytes)) as T;
  } catch {
    return null;
  }
}
